import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useImmer } from 'use-immer';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Image from 'components/common/ImageLoader';
import CopyIcon from 'assets/copy.svg';
import './index.css';

const ShowTokenCredentials = (props) => {
  const generateUserAPITokenState = useSelector(
    (state) => state.user.generateUserAPIToken?.data
  );

  return (
    <div className="show-api-credentials-container">
      <div className="mx-2 sm:mx-10 my-2 sm:my-10">
        <div className="text-xl"> Your API credentials </div>
        <div className="mt-4 bg-gray-100 rounded-md px-2">
          <div className="flex items-center justify-center py-2 px-2 ">
            <div className="font-bold w-2/12">Access Key</div>{' '}
            <div className="w-10/12 ml-4 flex items-center   px-4 py-1 rounded-md ">
              <code className="mr-2 break-all bg-yellow-200 px-1 py-1">
                {generateUserAPITokenState?.access_key}
              </code>
              <CopyToClipboard text={generateUserAPITokenState?.access_key}>
                <div className="w-6 h-6 cursor-pointer relative token-parent-tooltip">
                  <img src={CopyIcon} width="30" height="30" />
                  <div className="token-child-tooltip absolute top-0 bg-gray-600 text-white px-2 py-1 rounded-md">
                    {' '}
                    Copy to clipboard
                  </div>
                </div>
              </CopyToClipboard>
            </div>
          </div>

          <div className="flex items-center justify-center py-2 px-2">
            <div className="font-bold  w-2/12">Secret Key</div>{' '}
            <div className="w-10/12 ml-4 flex items-center   px-4 py-1 rounded-md">
              <code className="mr-2 break-all bg-yellow-200 px-1 py-1">
                {generateUserAPITokenState?.secret_key}
              </code>
              <CopyToClipboard text={generateUserAPITokenState?.secret_key}>
                <div className="w-6 h-6 cursor-pointer relative token-parent-tooltip">
                  <img src={CopyIcon} width="30" height="30" />
                  <div className="token-child-tooltip absolute top-0 bg-gray-600 text-white px-2 py-1 rounded-md">
                    {' '}
                    Copy to clipboard
                  </div>
                </div>
              </CopyToClipboard>
            </div>
          </div>
          <div className="flex items-center justify-center mt-2 pb-4">
            <div className=" text-white bg-red-600 py-1 px-4 rounded-full">
              <span className="font-bold">Important</span> : Secret key will no
              longer be displayed after closing this window
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowTokenCredentials;
